






























































import Vue from "vue";
import DropDown from "@/components/dropdown/DropDown.vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { ref, Ref, computed } from "@vue/composition-api";
import { PendingMultiSelectionResponse } from "@/common/composition/multi-selection-simple-items";
import { Filters } from "@/common/filters.global";
export default Vue.extend({
  props: ["value", "handler"],
  components: { DropDown, AppCheckbox },
  setup(props, { emit }) {
    const dropdownRef: Ref<{ close: Function } | null> = ref(null);

    const _handler = computed(
      () => props.handler as PendingMultiSelectionResponse
    );

    let save_changes = false;
    const apply = () => {
      save_changes = true;
      _handler.value.submit();
      emit("apply");
      dropdownRef.value && dropdownRef.value.close();
    };

    const on_close = () => {
      if (!save_changes) {
        _handler.value.discard();
      }
      save_changes = false;
    };

    const on_change = (val: any) => {
      _handler.value.toggle_item(val);
    };

    return {
      dropdownRef,
      apply,
      on_close,
      on_change,
      //@ts-ignore
      sources: props.handler.items,
    };
  },
});
